import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { displayGenericError } from "common/notifications";
import { submitPhoneNumber } from "api/api";
import EnterPhoneNumberLayout from "components/EnterPhoneNumberLayout";

import "./EnterPhoneNumberPage.css";

class EnterPhoneNumberPage extends Component {
  handleProceed = ({ phoneNumber, countryCode }) => {
    submitPhoneNumber({
      phone: phoneNumber,
      country: countryCode
    })
      .then(() => (window.location = "/"))
      .catch(displayGenericError);
  };

  render() {
    return (
        <EnterPhoneNumberLayout proceedHandler={this.handleProceed}/>
    );
  }
}

export default withRouter(EnterPhoneNumberPage);
